import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    src: String
  }

  connect() {
    this.timeout = setTimeout(() => {
      this.element.parentElement.reload()
    }, 2000);
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
